export enum HttpContentType {
    JSON = "application/json" as any,
    FORM_DATA = "application/x-www-form-urlencoded" as any,
    PLAIN_TEXT = "plain" as any
}